/**
 * Application Constants
 * Based on Helper.js and Constant.js analysis from PHASE1_ANALYSIS.md
 * 
 * NOTE: Most constants are now in helper.js for compatibility
 * This file contains socket/API specific constants
 */

export const DEVELOPMENT = import.meta.env.DEV || true;

export const BRAND = 'Jackopot';

export const SITE_URL = DEVELOPMENT
  ? 'https://jackopot.com'
  : 'https://jackopot.com';

export const SOCKET_URL = DEVELOPMENT
  ? 'wss://api.jackopot.com'
  : 'wss://api.playcrash.com';

export const API_URL = DEVELOPMENT
  ? 'https://api.jackopot.com'
  : 'https://api.playcrash.com';

// API Endpoints (from analysis)
export const API_ENDPOINTS = {
  RATE: '/rate',
  PLACE_BET: '/sportsbet/placeBet',
  GET_EXPOSURES: '/sportsbet/getUserExposures',
  SPORTS_CHECK: '/sportsCheck',
};

// Socket Event Constants (maintaining compatibility with old codebase)
// Using the same hash values as old Constant.js
export const C = {
  LOGIN_USER: "faf9ba208ad90e7313b6ffafde53b801",
  LOGIN_USER_GOOGLE: "383f7bf0257c3ef6cab20278dd1579be",
  REGISTER_USER: "0a2637735ee07dd5f0e5eba7b9ca1ce7",
  RESET_PASSWORD: "62a0b91a9b98a7ec19f27e72c13de207",
  USER_INFO: "18566cda79f670c2098360799275aa31",
  GAME_DETAILS: "657cdcaf1b9072c7d708bb3766bd3915",
  CREDIT: "660cb6fe7737d7b70e7a07b706b93f70",
  UPDATE_CREDIT: "80d8b773e76b21777faaccfbd3c2a687",
  SUBMIT_NEW_WITHDRAWL: "7c0b37955cf21c7f2f3773c1268edc08",
  SUBMIT_NEW_SWAP: "f2ca6e08d1e7d76f6ddcbcdubci73bd3",
  LOGOUT_USER: "1f7009c5312bab76e660578ecbe08350",
  RAKEBACK_AMOUNT: "4d0779dab780d8b773e7h6fl9jxd7hm7",
  ADD_RAKEBACK: "k2089ht7ae660578ed9gffgh8hkk7vxj",
};

// Socket Event Constants (maintaining compatibility with old codebase)
export const SOCKET_EVENTS = {
  // User events
  USER_INFO: 'user_info',
  USER_INFO_REQUEST: 'user_info',
  
  // Game events
  GAME_DETAILS: 'game_details',
  
  // Config events
  SITE_CONFIG_UPDATED: 'siteConfigUpdated',
  USER_CONFIG_UPDATED: 'userConfigUpdated',
  REQUEST_SITE_CONFIG: 'requestSiteConfig',
  REQUEST_USER_CONFIG: 'requestUserConfig',
  IDENTIFY: 'identify',
  
  // Bonus events
  BONUS_TIMER_UPDATE: 'bonusTimerUpdate',
  
  // Credit/Wallet events
  CREDIT: 'credit',
  UPDATE_CREDIT: 'update_credit',
  
  // Powered by (encoded)
  POWERED_BY: 'U2t5cGU6IEBQZWRyb3hhbQ',
};

// Game Types (from betting analysis)
export const GAME_TYPES = {
  MATCH_ODDS: 'MO',
  BOOKMAKER: 'BM',
  FANCY: 'FAN',
};

// Bet Types
export const BET_TYPES = {
  BACK: 'back',
  LAY: 'lay',
  YES: 'yes',
  NO: 'no',
};
